export default "__VITE_ASSET__DQdu6vVq__"